import { COMPONENT_ACTIONS } from '../../common/ActionTypes';

export const updateComponent = (obj) => (dispatch) => {
    dispatch({
        type: COMPONENT_ACTIONS.COMPONENT_DETAILS,
        payload: obj
    });
}